import { ReferencedEntry } from 'contentful';
import { useMemo } from 'react';

import { GridAssembly, Subject } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ShopTile, ShopTiledContainer } from 'src/api/contentful/contentTypes.shop';
import { Entries } from 'src/api/contentful/utilTypes';
import { getField } from 'src/utils/EntryUtil';

const convertShopTile = (tiles: Entries<ShopTile>) => {
  const shopTile = tiles.map(tile => ({
    fields: {
      internalName: getField(tile, 'name'),
      title: getField(tile, 'title'),
      image: getField(tile, 'image'),
      blurb: getField(tile, 'descriptionBlurb'),
    },
    sys: tile.sys,
    toPlainObject: tile.toPlainObject,
  } as ReferencedEntry<Subject>));
  return shopTile;
};

const convertShopTiledContainer = (tiledContainer: ReferencedEntry<ShopTiledContainer>, tiles: Entries<ShopTile>) => {
  return {
    title: getField(tiledContainer, 'title'),
    internalName: getField(tiledContainer, 'name'),
    backgroundColor: getField(tiledContainer, 'backgroundColor'),
    items: convertShopTile(tiles),
  };
};

export const useShopFooter = (tiledContainer: ReferencedEntry<ShopTiledContainer>) => {
  return useMemo(() => {
    const tiles = getField(tiledContainer, 'tiles', []);
    if (!tiles.length) return;
    return {
      ...tiledContainer,
      fields: convertShopTiledContainer(tiledContainer, tiles),
      sys: tiledContainer.sys,
      toPlainObject: tiledContainer.toPlainObject,
    } as ReferencedEntry<GridAssembly>;
  }, [ tiledContainer ]);
};
